const STAGE_HOSTNAME = 'https://www.msmaster.qa.paypal.com';

export function getHost() {
  const { host, protocol } = window.location;
  return host.includes('localhost') ? STAGE_HOSTNAME : `${protocol}//${host}`;
}
